import React from 'react'
import Navigation from './Navigation'
import styled from 'styled-components'
// import '../styles/main.css'
import { Head } from './Head'
import PrivacyConsent from './PrivacyConsent'

const Layout = ({ children }) => {
	return (
		<>
			<Head />
			<StyledLayout>
				<PrivacyConsent />
				{children}

				<Navigation />
			</StyledLayout>
		</>
	)
}

const StyledLayout = styled.div`
	// margin: 35px 0;
`

export default Layout
